module.exports = __webpack_public_path__ + "static/media/details-4.7569a316.jpeg";